const firebaseConfig = {
  apiKey: "AIzaSyBzIgHxx0eRoQg7mrsYutqUSaA6BjYNQjY",
  authDomain: "foodota-firebase-mongodb.firebaseapp.com",
  projectId: "foodota-firebase-mongodb",
  storageBucket: "foodota-firebase-mongodb.appspot.com",
  messagingSenderId: "913872945742",
  appId: "1:913872945742:web:7a2323441a6a2cda9ff91f"
};
export default firebaseConfig;